import type { PropsWithChildren } from 'react';
import { useEffect } from 'react';
import { useWizard } from '@zillow/zrs-rental-applications';
import { VisuallyHidden } from '@zillow/constellation-10';
import { useQuery } from '@zg-rentals/react-query5';
import loadJsc from './loadJsc';
import { useSetPassiveAuthData } from '../contexts/IdVerificationContext';
import IdvSpinner from '../IdvSpinner';
import { IdvStep } from '../../../models';

function usePassiveAuth() {
  const { currentStep } = useWizard();

  return useQuery({
    queryKey: ['passiveAuth'],
    queryFn: async () => {
      const globalWithAdx = global as typeof globalThis & {
        adx?: any; // eslint-disable-line @typescript-eslint/no-explicit-any
      };

      if (!globalWithAdx.adx) {
        loadJsc();
      }

      const { adx } = globalWithAdx;

      return new Promise((resolve) =>
        adx.initiate(() => {
          adx.validate('user_prefs');
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const jsc = (document.getElementById('user_prefs') as any).value;
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const hdimPayload = (document.getElementById('user_prefs2') as any).value;
          resolve({ jsc, hdimPayload });
        }),
      );
    },
    enabled: currentStep === IdvStep.PersonalInfoStep,
  });
}

function LoadPassiveAuth() {
  return (
    <VisuallyHidden>
      <form id="form">
        <input type="hidden" name="user_prefs" id="user_prefs" />
        <input type="hidden" name="user_prefs2" id="user_prefs2" />
      </form>
    </VisuallyHidden>
  );
}

export default function PassiveAuthWrapper({ children }: PropsWithChildren) {
  const { currentStep } = useWizard();
  const setPassiveAuthData = useSetPassiveAuthData();
  const { isFetched, data } = usePassiveAuth();
  const passiveAuthData = data as Record<string, string>;

  useEffect(() => {
    if (isFetched) {
      setPassiveAuthData({
        jsc: passiveAuthData?.jsc,
        hdimPayload: passiveAuthData?.hdimPayload,
      });
    }
  }, [isFetched, setPassiveAuthData, passiveAuthData]);

  if (currentStep !== IdvStep.PersonalInfoStep) {
    return children;
  }

  if (!isFetched) {
    return (
      <>
        <IdvSpinner />
        <LoadPassiveAuth />
      </>
    );
  }

  return children;
}
